export default __webpack_public_path__ + "static/media/multipass-badge.fc2b1797.svg";